import React from "react";
import {FeedbackOverviewUi} from "../../../../../api/generated";
import styles from "./FeedbackKpiTiles.module.css";

const NO_VALUE = "—";

interface FeedbackKpiTilesProps {
    overview?: FeedbackOverviewUi
    onShowAllRatings: () => void
    onShowNegativeWithComment: () => void
    onShowAllSurveys: () => void
    onShowLowSurveys: () => void
}

export const FeedbackKpiTiles: React.FC<FeedbackKpiTilesProps> = ({
                                                                      overview,
                                                                      onShowAllRatings,
                                                                      onShowNegativeWithComment,
                                                                      onShowAllSurveys,
                                                                      onShowLowSurveys
                                                                  }) => {
    const positiveRate = overview?.positiveFeedbackRate == null
        ? NO_VALUE
        : `${Math.round(overview.positiveFeedbackRate * 100)}%`;
    const averageRating = overview?.averageSurveyRating == null
        ? NO_VALUE
        : `${overview.averageSurveyRating.toFixed(1)} / 5`;

    return <div className={styles.grid}>
        <button type="button" className={styles.tile} onClick={onShowAllRatings}>
            <span className={styles.label}>Positive feedback</span>
            <span className={styles.value}>{positiveRate}</span>
            <span className={styles.hint}>
                {overview ? `${overview.positiveFeedbackCount} of ${overview.feedbackCount} votes` : NO_VALUE}
            </span>
        </button>
        <button type="button" className={styles.tile} onClick={onShowNegativeWithComment}>
            <span className={styles.label}>Not helpful, with comment</span>
            <span className={`${styles.value} ${styles.alert}`}>{overview?.negativeWithCommentCount ?? NO_VALUE}</span>
            <span className={styles.hint}>Show these →</span>
        </button>
        <button type="button" className={styles.tile} onClick={onShowAllSurveys}>
            <span className={styles.label}>Avg survey rating</span>
            <span className={styles.value}>{averageRating}</span>
            <span className={styles.hint}>{overview ? `${overview.surveyCount} surveys` : NO_VALUE}</span>
        </button>
        <button type="button" className={styles.tile} onClick={onShowLowSurveys}>
            <span className={styles.label}>Low survey ratings (1–2)</span>
            <span className={`${styles.value} ${styles.alert}`}>{overview?.lowSurveyCount ?? NO_VALUE}</span>
            <span className={styles.hint}>Show these →</span>
        </button>
    </div>
}
